import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { BadgePenaltyCounter } from "./BadgePenaltyCounter";

const MAX_PENALTY_COUNT = 3;

interface UnverifiedBadgeCounterProps {
  unverifiedBadgeCount: number;
  isError?: boolean;
}

export function UnverifiedBadgeCounter(props: UnverifiedBadgeCounterProps) {
  const { unverifiedBadgeCount, isError = false } = props;

  return (
    <Stack alignItems="center" spacing={4}>
      <Text variant="body2" color={(theme) => theme.palette.text.tertiary}>
        {unverifiedBadgeCount === 1 ? "Unverified badge" : "Unverified badges"}
      </Text>
      <Stack direction="row" spacing={4}>
        {Array.from({ length: MAX_PENALTY_COUNT }).map((_, index) => (
          <BadgePenaltyCounter
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isFilled={index < unverifiedBadgeCount}
            isError={isError}
          />
        ))}
      </Stack>
    </Stack>
  );
}
